import { getTermsValue } from '@/packages/JsonQuery';
import { EGarageStatus } from '@/packages/api-models/common/json_query';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagGarageStatusSchema } from '../types';

const TEXT_MAP: { [key in EGarageStatus]: string } = {
  [EGarageStatus.Ownership]: 'Собственность',
  [EGarageStatus.Agreement]: 'По доверенности',
  [EGarageStatus.Cooperative]: 'Кооператив',
};

export const garageStatus: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermsValue('garage_status')(jsonQuery) || [];

    const tagsGroup: TagGarageStatusSchema[] = value.map(key => ({
      group: 'garageStatus',
      text: TEXT_MAP[key],
      data: key,
    }));

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagGarageStatusSchema) {
    const currentValue = getTermsValue('garage_status')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setGarageStatus',
      arguments: [nextValue],
    });
  },
};
